import React, { useState, useEffect } from 'react'
import { Button, Skeleton, Result, Affix } from 'antd'
import { RocketOutlined } from '@ant-design/icons'
import { IServiceItem } from '../../../network/models/ServiceTypes'
import request from '../../../network/request'
import styles from './index.module.scss'
import './reset.scss'

declare global {
  interface Window {
    xdragon: any;
  }
}

export default function Entry() {
  const [serviceList, setServiceList] = useState<IServiceItem[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  useEffect(() => {
    setLoading(true)
    getServicesData()
  }, [])

  const getServicesData = async () => {
    try {
      const res: IServiceItem[] = await request.get('/dragon/service/config')
      res.sort((a, b) => b.seq - a.seq)
      setServiceList(res)
    } catch (err) {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const handleReload = () => {
    setLoading(true)
    setError(false)
    getServicesData()
  }

  const handleLinkToService = (item: IServiceItem) => {
    if(window.xdragon) {
      try {
        window.xdragon.callHandler('openDefaultBroswer', {"url": item.link})
      } catch(err) {
        window.location.href = item.link
      }
      return
    }
    
    window.location.href = item.link
  }

  return (
    <div className={styles.pageWrap}>
      <Affix offsetTop={0}>
        <div className={styles.pageHeader}>
          <h3 className={styles.title}>服务</h3>
        </div>
      </Affix>
      <div className={styles.pageContent}>
        {error ? (
          <Result
            subTitle="数据加载失败，请稍后重试"
            extra={
              <Button type="primary" onClick={handleReload}>
                重新加载
              </Button>
            }
          />
        ) : loading ? (
          <div className="loadingWrap">
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
            <Skeleton.Button active />
          </div>
        ) : (
          <div className={styles.serviceListWrap}>
            {serviceList?.length > 0 ? (
              serviceList.map((item) => {
                return (
                  <div
                    className={styles.serviceItem}
                    key={item.name}
                    onClick={() => handleLinkToService(item)}
                  >
                    <div className={styles.icon}>
                      <img src={item?.icon} alt="" />
                    </div>
                    <div className={styles.title}>{item.name}</div>
                  </div>
                )
              })
            ) : (
              <div className={styles.emptyWrap}>
                <Result
                  icon={<RocketOutlined />}
                  title="敬请期待"
                  subTitle="SE 专区服务暂未上线"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
